import { render } from "./Files.vue?vue&type=template&id=962e80a8&scoped=true&ts=true"
import script from "./Files.vue?vue&type=script&lang=ts"
export * from "./Files.vue?vue&type=script&lang=ts"

import "./Files.vue?vue&type=style&index=0&id=962e80a8&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-962e80a8"]])

export default __exports__